import script from "./EmployeeForm.vue?vue&type=script&lang=ts&setup=true"
export * from "./EmployeeForm.vue?vue&type=script&lang=ts&setup=true"

import "./EmployeeForm.vue?vue&type=style&index=0&id=6ea2c56d&lang=scss"

const __exports__ = script;

export default __exports__